import styles from '../components/MailRibbon.scss';
import { UpNextV2 } from 'owa-upnext-v2';
import * as React from 'react';
import { MonarchWin32Toggle, isToggleEnabled } from 'native-newoutlook-toggle';
import getFullComposeShowingInTabContentArea from 'owa-mail-compose-actions/lib/selectors/getFullComposeShowingInTabContentArea';

const upNextButtonStyles = {
    root: styles.upNextButtonRoot,
    flexContainer: {
        height: 'auto',
        lineHeight: '15px',
    },
};

export function getExtraTopRibbonControls(): JSX.Element[] {
    let topRibbonControls: JSX.Element[] = [];

    const isFullCompose = getFullComposeShowingInTabContentArea() !== null;
    if (!isFullCompose) {
        // "Up next" calendar peek
        topRibbonControls.push(
            <div
                key="UpNextV2_ExtraTopRibbonControls"
                style={{ display: 'flex', alignItems: 'center' }}>
                <UpNextV2 containerStyle={upNextButtonStyles} />
            </div>
        );

        if (isToggleEnabled()) {
            // Monarch - Win32 toggle
            topRibbonControls.push(
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <MonarchWin32Toggle />
                </div>
            );
        }
    }

    return topRibbonControls;
}
